export default {
    sectionImageList: {
        'col-3': "",
        'col-4': "",
        default: "col-span-2 md:col-span-4"
    },
    sectionGridCol: {
        "cols-2": "grid grid-cols-2 md:grid-cols-2",
        "cols-3": "grid grid-cols-2 md:grid-cols-3",
        "cols-4": "grid grid-cols-2 md:grid-cols-4",
        "cols-default": " grid grid-cols-2 md:grid-cols-4"
    }
}